<div class="form-floating mb-3" style="width: 100%;">
  <input type="text"  id="GrundSelect" style="width:100%" class="form-control" [ngModel]="CurrentSelected" (ngModelChange)="onValueChangeEvent($event)"
			[ngbTypeahead]="search"
			[inputFormatter]="formatter"
			[resultFormatter]="formatter"
			[selectOnExact]="true"/>
  <label for="freitext_A">Freitext A</label>
</div>
